import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TimerPipe } from './timer.pipe';
@NgModule({
  declarations: [TimerPipe],
  imports: [CommonModule],
  exports: [TimerPipe]
})
export class TimerModule {}
